import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import * as fromShipmentActivities from './+state/shipment-activities.reducer';
import {ShipmentActivitiesEffects} from './+state/shipment-activities.effects';
import {ShipmentActivitiesFacade} from './+state/shipment-activities.facade';
import {SharedStoresShipmentActivitiesConfig} from "./shared-stores-shipment-activities.config";

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(
            fromShipmentActivities.SHIPMENTACTIVITIES_FEATURE_KEY,
            fromShipmentActivities.reducer
        ),
        EffectsModule.forFeature([ShipmentActivitiesEffects]),
    ],
    providers: [ShipmentActivitiesFacade],
})
export class SharedStoresShipmentActivitiesModule {

    static forFeature(
        config: SharedStoresShipmentActivitiesConfig
    ): ModuleWithProviders<SharedStoresShipmentActivitiesModule> {
        return {
            ngModule: SharedStoresShipmentActivitiesModule,
            providers: [config.service]
        }
    }

}
